import React from 'react';
import PropTypes from 'prop-types';

function Label(props){
    if (props.playing === true) {
        return (<div className="label playing">Now Playing</div>);
    } else if (props.watched === true) {
        return (<div className="label watched">Watched</div>);
    }
    else if(props.comingsoon === true){
        return (<div className="label coming-soon">Coming Soon</div>);

    }
    return null;
}

Label.propTypes = {
	"playing": PropTypes.bool,
	"comingsoon": PropTypes.bool,
	"watched": PropTypes.bool
}

Label.defaultProps = {
	"playing": false,
	"comingsoon": false,
	"watched": false
}

export default Label;